import {
  mockCurrencySettings,
  mockTaxSettings,
} from '@wix/app-market-components';
import type { IAppPlans } from '../../../../services/apps-plans';
import type { IPricingModel } from '../../../../services/pricing-model';

export const emptyAppPlansMock: IAppPlans = {
  appId: '123456',
  taxSettings: mockTaxSettings,
  currency: mockCurrencySettings,
  plans: [],
};

export const emptyPricingModelMock: IPricingModel = {
  appId: '123456',
  freeTrialDays: 0,
  isExternalPricing: false,
  plans: [],
};
